/* eslint-disable */
import { IKund } from "../../leverantorsorder/models/leverantororder-models";
import { AvtalsansvarigDTO } from "../../models/AvtalsansvarigDTO";
import { KundorderradDTO } from "./KundorderradDTO";

export class KundorderDetailRequestDTO {

    public id: number;
    public beskrivning: string;
    public kundordertyp: string;
    public mattslag: string;
    public kund: KundDTO;
    public avtalsansvarig: AvtalsansvarigDTO;
    public kundorderrader: KundorderradDTO[];
    public rowVersion: number[];
    public changeType: string;

    constructor() {
        this.id = undefined;
        this.beskrivning = undefined;
        this.kundordertyp = undefined;
        this.mattslag = undefined;
        this.kund = undefined;
        this.avtalsansvarig = undefined;
        this.kundorderrader = undefined;
        this.rowVersion = undefined;
        this.changeType = undefined;
    }
}

export class KundDTO implements IKund  {

    id: number;
    namn: string;

    constructor() {
        this.id = undefined;
        this.namn = undefined;
    }
}
